$(document).ready(function() {

	var $postcard_form = $("#postcard_form");
	
	if($postcard_form !== undefined) {
		
		
		$postcard_form.validate({
			debug: true,
            invalidHandler: function (event, validator) {
                
                // remove waiting spinner form submit button
				// $thisForm.removeClass("submitting");
				/*
				// 'this' refers to the form
				var errors = validator.numberOfInvalids();
				if (errors) {
					var message = errors == 1
					? 'You missed 1 field. It has been highlighted'
					: 'You missed ' + errors + ' fields. They have been highlighted';
					$("div.error span").html(message);
					$("div.error").show();
				} else {
					$("div.error").hide();
				}
				*/
            },
            submitHandler: function(form) {
				
				event.preventDefault();
				
				$postcard_form.find(':submit').prop( "disabled", true );
				$postcard_form.find(':submit').addClass('button--loading');
				
			    var request_url = $postcard_form.attr('action');
				
				var $postcard_notice = $('#postcard_notice');
				if($postcard_notice !== undefined) {
					$postcard_notice.remove();
				}
				
				$.ajax({
					url: request_url,
					type: "POST",
					data : $("#postcard_form").serialize(),
					dataType: 'json',
					success: function(response) {
						
						$postcard_form.find('.postcard_form--initial').hide();
						$postcard_form.find('.postcard_form--success').show();
						
						$postcard_form.find(':submit').prop( "disabled", true );
						$postcard_form.find(':submit').removeClass('button--loading');
						$postcard_form.find(':submit').addClass('button--success');
						// $postcard_form.find(':submit').text('Erfolg');
						// $postcard_form.hide();
						
					},
					error: function(error) {
						
						if( error.responseJSON !== undefined ){ 
							$postcard_form.append( error.responseJSON.content );
						}
						
						$postcard_form.find(':submit').prop( "disabled", false );
						$postcard_form.find(':submit').removeClass('button--loading');
						
					}
				
				});
					
			},
            errorPlacement: function (error, element) {
                if (element.attr("type") == "checkbox") {
                    if ($(element).parents('.checkbox__error-container')) {
                        error.appendTo($(element).parents('.checkbox__error-container'));
                    } else {
                        error.appendTo($(element).closest('.form__group'));
                    }
                } else if (element.attr("type") == "radio") {
                    if ($(element).parents('.radio__error-container')) {
                        error.appendTo($(element).parents('.radio__error-container'));
                    } else {
                        error.appendTo($(element).closest('.form__group'));
                    }
                } else {
                    // something else if it's not a checkbox or radio
                    error.appendTo($(element).closest('.form__group'));
                }
            }

        });

		// Require numbers for fields with data-field-type="number"
        $('[data-field-type="number"]', $postcard_form).rules('add', {
			number: true
		});
		
		
		/*
		$("#postcard_form").submit(function(event) {
			
			event.preventDefault();
				
			$postcard_form.find(':submit').prop( "disabled", true );
			$postcard_form.find(':submit').addClass('button--loading');
			
		    var request_url = $postcard_form.attr('action');
			
			var $postcard_notice = $('#postcard_notice');
			if($postcard_notice !== undefined) {
				$postcard_notice.remove();
			}
			
			$.ajax({
				url: request_url,
				type: "POST",
				data : $("#postcard_form").serialize(),
				dataType: 'json',
				success: function(response) {
					
					$postcard_form.find('.postcard_form--initial').hide();
					$postcard_form.find('.postcard_form--success').show();
					
					$postcard_form.find(':submit').prop( "disabled", true );
					$postcard_form.find(':submit').removeClass('button--loading');
					$postcard_form.find(':submit').addClass('button--success');
					// $postcard_form.find(':submit').text('Erfolg');
					// $postcard_form.hide();
					
				},
				error: function(error) {
					
					if( error.responseJSON !== undefined ){ 
						$postcard_form.append( error.responseJSON.content );
					}
					
					$postcard_form.find(':submit').prop( "disabled", false );
					$postcard_form.find(':submit').removeClass('button--loading');
					
				}
			
			});
			
			// }
			
		});	
		*/
	}

});